require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./research-cancer-stem-cells.json") })
        }
      }, "path---research-cancer-stem-cells");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---research-cancer-stem-cells!./.cache/json/research-cancer-stem-cells.json
// module id = 484
// module chunks = 231608221292675